import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// import styles bundle
import "swiper/css/bundle";

export default class Main {
    constructor() {
        this.refreshEvent = new CustomEvent("onRefresh");
        this.swiperInstance = null;
        this.init();
    }

    init() {
        this.tabFunc();
        this.acc();
        this.swiper();
    }

    swiper() {
        // init Swiper:
        this.swiperInstance = new Swiper(".swiper", {
            loop: true,
            speed: 600,

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        //switches
        const slideswitch = [...document.querySelectorAll(".js-slideswitch")];

        // slideswitch.forEach((btn) => {
        //     btn.addEventListener("click", () => {
        //         const tgt = btn.getAttribute("data-slide");
        //         slideswitch.forEach((btn) => {
        //             btn.classList.remove("-active");
        //             if (btn.getAttribute("data-counterslide") === tgt) {
        //                 btn.classList.add("-active");
        //             }
        //         });

        //         //swiper制御
        //         this.swiperInstance.slideToLoop(parseInt(tgt));
        //     });
        // });

        this.swiperInstance.on("slideChange", (e) => {
            slideswitch.forEach((btn) => {
                btn.classList.remove("-active");
                if (parseInt(btn.getAttribute("data-slide")) === e.realIndex) {
                    btn.classList.add("-active");
                }
            });
        });

        const swiperWrapper = document.querySelector(".swiper-wrapper");
        const playbtn = document.querySelector(".movie__container__play");

        swiperWrapper.addEventListener("mouseenter", () => {
            playbtn.classList.add("-mouseon");
        });
        swiperWrapper.addEventListener("mouseleave", () => {
            playbtn.classList.remove("-mouseon");
        });
    }

    tabFunc() {
        const triggers = [...document.querySelectorAll(".js-tabswitch")];
        const tabs = [...document.querySelectorAll(".js-tab")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                triggers.forEach((el) => el.classList.remove("-active"));
                tabs.forEach((el) => el.classList.remove("-active"));
                el.classList.add("-active");

                const tgt = el.getAttribute("data-tab");
                const tab = document.querySelector(`.js-tab[data-tab="${tgt}"]`);
                tab && tab.classList.add("-active");

                if (tgt === "tips") {
                    this.setInitialOpenAcc();
                }

                window.dispatchEvent(this.refreshEvent);
            });
        });
    }

    setInitialOpenAcc() {
        const triggers = [...document.querySelectorAll(".js-acctrigger")];

        triggers.forEach((el) => {
            //initialOpen
            if (el.classList.contains("-active")) {
                const wrapper = el.nextElementSibling;
                const height = wrapper.querySelector(".js-acccont_inner").offsetHeight;
                wrapper.style.height = `${height}px`;
                //ページの高さが変わるのでrefresh
                window.dispatchEvent(this.refreshEvent);
                wrapper.classList.add("-acc_open");
            }
        });
    }

    acc() {
        const triggers = [...document.querySelectorAll(".js-acctrigger")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                const wrapper = el.nextElementSibling;
                const height = wrapper.querySelector(".js-acccont_inner").offsetHeight;

                el.classList.toggle("-active");

                if (getComputedStyle(wrapper, null).getPropertyValue("height") === "0px") {
                    wrapper.style.height = `${height}px`;
                    wrapper.classList.add("-acc_open");
                } else {
                    wrapper.style.height = 0;
                    wrapper.classList.remove("-acc_open");
                }

                //ページの高さが変わるのでrefresh
                window.dispatchEvent(this.refreshEvent);
            });
        });
    }
}
